import { Component, OnInit, ElementRef, ViewChild, Output, EventEmitter } from "@angular/core";
import { environment } from "../../environments/environment";
import { select } from "@angular-redux/store";
import { TranslateService } from "@ngx-translate/core";
import { UserSettingsService } from "../pb-screen/services/usersettings.service";
import { ToastrService } from "ngx-toastr";
import { map, take } from "rxjs/operators";
import { combineLatest } from "rxjs";
import { CopySettingUser } from "./models/copy-setting-user";
import { AzureUser } from "./models/azure-user";
import { Observable } from "rxjs/Observable";

@Component({
  moduleId: module.id,
  selector: "copy-setting-modal",
  styleUrls: ["copy-setting-modal.component.scss"],
  templateUrl: "copy-setting-modal.component.html"
})
export class CopySettingComponent implements OnInit {
  @Output("companyName") companyName = environment.envName;
  @Output() closed: EventEmitter<undefined> = new EventEmitter<undefined>();

  @select("azureUsers") private azureUsers$: Observable<AzureUser[]>;

  @ViewChild("modal") private modal: ElementRef;

  users: CopySettingUser[] = [];
  fromUser: CopySettingUser;
  toUsers: CopySettingUser[];
  isLoading = false;


  constructor(
    private translate: TranslateService,
    private userSettingsService: UserSettingsService,
    private toastr: ToastrService
  ) {
  }

  ngOnInit() {
    this.fetchAllUsers();
  }

  closeModal() {
    this.modal.nativeElement.click();
    this.closed.emit();
  }

  copySetting() {
    this.isLoading = true;

    const copyRequests = this.toUsers.map(toUser =>
      this.userSettingsService.CopyUserSetting(toUser.id, this.fromUser.id).pipe(
        take(1)
      )
    );

    combineLatest([...copyRequests, this.translate.get("COPYSETTING.COMPLETED")]).subscribe(
      ([...results]) => {
        const message = results.pop()
          .replace("{{fromName}}", this.fromUser.name)
          .replace("{{toName}}", this.toUsers.map(user => user.name).join(", "));

        this.toastr.success(message);
        this.isLoading = false;
      }, error => {
        console.error(error);
        this.isLoading = false;
      }
    );
  }

  private fetchAllUsers() {
    this.isLoading = true;

    this.azureUsers$.pipe(
      take(1),
      map((users: AzureUser[]) => this.mapAzureUsersToUsers(users))
    ).subscribe((users: CopySettingUser[]) => {
        this.users = users;
        this.isLoading = false;
      }, error => {
        console.error(error);
        this.isLoading = false;
      }
    );
  }

  private mapAzureUsersToUsers(users: AzureUser[]): CopySettingUser[] {
    return users.map((azureUser: AzureUser) => {
      return { name: azureUser.displayName, id: azureUser.objectId };
    });
  }
}
